/**
 * Created by rathompson on 5/2/22
 * File: FiltersBar
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

/**
 *   TODO: Brief what is this component/class do
 */
import ConnectedTableFilter from '../../../../common/components/table/tableFilter/ConnectedTableFilter'
import { ASSOCIATION_TABLE_SEARCH_PLACEHOLDER } from '../../../constants/LabelConstants'
import styled from 'styled-components'
// import { Select } from '@panwds/react-ui'
// import PropTypes from 'prop-types'

const CONTAINER = styled.div`
  span {
    &.tw-border-solid.tw-flex.tw-items-center.tw-space-x-1.tw-px-2.tw-py-1.tw-h-8.tw-border.tw-rounded.tw-box-border.tw-border-gray-300.tw-bg-white {
      min-width: 240px;
    }
  }
  button {
    color: #333333;
  }
  input[type="text"] {
    min-width: 240px;
  }
`

const FiltersBar = ({ searchCallback = () => null }) => {

  // const [model, setModel] = useState(null)
  // const [app, setApp] = useState(null)
  //
  // const modelItems = useMemo(() => [
  //   {
  //     id: 'all',
  //     value: 'All Models'
  //   }
  // ], [])
  //
  // const appItems = useMemo(() => [
  //   {
  //     id: 'all',
  //     value: 'All Apps'
  //   }
  // ], [])

  return (
    <CONTAINER className='tw-flex tw-gap-2 tw-p-3 tw-border-l tw-border-r tw-border-t tw-border-b-0 tw-border-gray-200 dark:tw-border-gray-950 tw-border-solid'>
      <ConnectedTableFilter placeholder={ASSOCIATION_TABLE_SEARCH_PLACEHOLDER} {...{ searchCallback }}/>
      {/*<Select*/}
      {/*  selectedItem={model ?? modelItems[0]}*/}
      {/*  items={modelItems}*/}
      {/*  onChange={change => {*/}
      {/*    setModel(change.selectedItem)*/}
      {/*  }}*/}
      {/*/>*/}
      {/*<Select*/}
      {/*  selectedItem={app ?? appItems[0]}*/}
      {/*  items={appItems}*/}
      {/*  onChange={change => {*/}
      {/*    setApp(change.selectedItem)*/}
      {/*  }}*/}
      {/*/>*/}
    </CONTAINER>
  )
}

FiltersBar.propTypes = {}
export default FiltersBar
